import { FluentButton } from 'owa-fluent-v9-shims';
import { bookingsMetaOSStaticFeedbackText } from './BookingsMetaOSStaticFeedback.locstring.json';
import getPrimaryButtonStyles from 'bookings-resources/lib/styles/getPrimaryButtonStyles';
import { observer } from 'owa-mobx-react';
import loc from 'owa-localize';
import React from 'react';
import RenderFeedbackDialog from './RenderFeedbackDialog';
import { Stack } from '@fluentui/react/lib/Stack';
import type { IStackStyles } from '@fluentui/react/lib/Stack';
import { getPaletteAsRawColors } from 'owa-theme';
import { bookingsAppName } from 'diagnostics-and-support';

const iconProps = {
    iconName: 'Feedback',
};

const feedbackButtonStackStyle: IStackStyles = {
    root: {
        position: 'absolute',
        right: '8%',
        bottom: '1%',
    },
};

const BookingsMetaOSStaticFeedback = () => {
    const onClickFeedbackButton = React.useCallback(() => {
        RenderFeedbackDialog(bookingsAppName);
    }, []);

    return (
        <Stack styles={feedbackButtonStackStyle}>
            <FluentButton
                text={loc(bookingsMetaOSStaticFeedbackText)}
                styles={getPrimaryButtonStyles({
                    root: {
                        borderRadius: '20px',
                        backgroundColor: getPaletteAsRawColors().themeDarker,
                        zIndex: 5,
                    },
                    label: {
                        color: getPaletteAsRawColors().white,
                    },
                    icon: {
                        color: getPaletteAsRawColors().white,
                    },
                })}
                onClick={onClickFeedbackButton}
                iconProps={iconProps}
            />
        </Stack>
    );
};

export default observer(BookingsMetaOSStaticFeedback, 'BookingsMetaOSStaticFeedback');
